import Catalog from '../components/Catalog'

const routes = [
  {
    path: '',
    // name: 'bpm.catalog',
    component: Catalog
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/apps/bpm/catalog/router/routes.js